import { cn } from "../../lib/utils";

export interface SkeletonProps {
  className?: string;
}

/** Loading placeholder block. Size it with className (h-*, w-*). */
export function Skeleton({ className }: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cn("animate-pulse rounded-xl bg-surface-3", className)}
    />
  );
}

export interface SkeletonTextProps {
  lines?: number;
  className?: string;
}

/** A few text-height bars, the last one shorter. */
export function SkeletonText({ lines = 3, className }: SkeletonTextProps) {
  return (
    <div aria-hidden="true" className={cn("flex flex-col gap-2", className)}>
      {Array.from({ length: lines }, (_, i) => (
        <Skeleton
          key={i}
          className={cn("h-3.5", i === lines - 1 ? "w-2/3" : "w-full")}
        />
      ))}
    </div>
  );
}
